import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { Pages } from '../pages.service';

import { UsuarioComponent } from './usuario.component';

const routes: Routes = [
    Pages.childRoutes([
        { path: 'usuarios', component: UsuarioComponent },
    ])
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
    providers: []
})
export class UsuarioRoutingModule {}
